export default __webpack_public_path__ + "static/media/faq_2_img_1.03a64c0d.svg";